"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamesList = void 0;
class GamesList extends Array {
    constructor() {
        super(...arguments);
        this.getDateStartSorted = () => this;
    }
    get isFeatured() {
        return this[0];
    }
    get topList() {
        return this.slice(1);
    }
}
exports.GamesList = GamesList;
//# sourceMappingURL=GamesList.js.map